import script from "./TimeRatioReportingServiceProvider.vue?vue&type=script&lang=ts&setup=true"
export * from "./TimeRatioReportingServiceProvider.vue?vue&type=script&lang=ts&setup=true"

import "./TimeRatioReportingServiceProvider.vue?vue&type=style&index=0&id=19fd1cad&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19fd1cad"]])

export default __exports__